/**
 * PasswordReset container
 */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PasswordReset from '../../Components/PasswordReset/PasswordReset';
import { loggedInSelector } from '../App/selectors';
import PasswordResetAPI from '../../Lib/Api/password-reset';

function Component(props) {
  return <PasswordReset {...props} />;
}

/**
 * Properties to be provided to the PasswordReset component
 *
 * @param {object} state global state
 */
const mapStateToProps = (state) => ({
  isLoggedIn: loggedInSelector(state),
});

/**
 * Connects passwordReset state to the PasswordReset component
 *
 * @param {object} mapStateToProps data object to become props for the PasswordReset component
 * @param {object} mapDispatchToProps passwordReset actions to be dispatched to reducer
 */
export default withRouter(
  connect(
    mapStateToProps,
    {},
  )((props) => (
    <Component
      resetPassword={PasswordResetAPI.get}
      updatePassword={PasswordResetAPI.update}
      {...props}
    />
  )),
);
